<template>
  <div class="text-xs-center">
    <div class="text-xs-center">
      {{ $t('online_payment_system_for_websites_and_applications') }}
    </div>
    <div class="text-xs-center mb-4">
      {{ $t('please_enter_your_information_to_proceed_with_the_payment') }}
    </div>
    <div :class="{ 'has-error': errors.has('email') }" class="mb-1">
      <v-text-field
        outline
        :label="$t('Email Address')"
        name="email"
        :data-vv-as="$t('Email Address')"
        v-model="email"
        v-validate="{
          required: true,
          email: true
        }"
        type="email"
        light
        :color="theme.color"
        :error="errors.has('email') ? true : false"
        :error-messages="errors.has('email') ? errors.first('email') : ''"
      ></v-text-field>
    </div>
    <form
      v-if="formData"
      style="display: none"
      ref="formPaySolution"
      id="formPaySolution"
      action="https://payments.paysolutions.asia/payment"
      method="POST"
    >
      Customer E-mail:
      <input
        type="text"
        name="customeremail"
        v-model="formData.customeremail"
      />
      <br />
      Product Detail:
      <input
        type="text"
        name="productdetail"
        v-model="formData.productdetail"
      />
      <br />
      Reference No.:
      <input type="text" name="refno" v-model="formData.refNo" />
      <br />
      Merchant ID:
      <input type="text" name="merchantid" v-model="formData.merchant" />
      <br />
      Currency Code:
      <input type="text" name="cc" v-model="formData.cc" />
      <br />
      Total:
      <input type="text" name="total" :value="formData.total" />
      <br />
      Lang:
      <input type="text" name="lang" v-model="formData.lang" />
      <br />
      <input type="text" name="returnurl" :value="returnurl" />
      <br />
      <!-- <input type="text" name="postbackurl" v-model="formData.postbackurl" />
      <br /> -->
      <v-btn type="submit" :color="theme.color" dark>go</v-btn>
    </form>
    <v-btn
      @click="handleProceed"
      :color="theme.color"
      :loading="loading || paymentLoading"
      :disabled="disabled"
      dark
      >Pay with Paysolutions</v-btn
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  inject: ['$validator'],
  props: {
    setting: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    }),
    returnurl() {
      return this.$store.state.paymentGatewayData
        ? `${window.location.origin}/paysolution-return-url/${this.$store.state.paymentGatewayData.orderid}?pageid=${this.$store.state.paymentGatewayData.pageid}&userid=${this.$store.state.paymentGatewayData.userid}&sessiontoken=${this.$store.state.paymentGatewayData.sessiontoken}&order_no=${this.$store.state.paymentGatewayData.orderid}&referenceNo=${this.$store.state.paymentGatewayData.refNo}&amount=${this.$store.state.paymentGatewayData.total}`
        : ''
    }
  },
  data() {
    return {
      email: '',
      formData: undefined,
      paymentLoading: false
    }
  },
  methods: {
    async handleProceed() {
      const result = await this.$validator.validateAll()
      if (result) {
        this.paymentLoading = true
        this.$store.commit('setPaysolutionCustomerData', {
          email: this.email
        })
        this.$emit('onProceed', {
          onProceed: () => {
            this.formData = this.$store.state.paymentGatewayData
            this.$nextTick(() => {
              this.$refs.formPaySolution.submit()
              this.paymentLoading = false
            })
          },
          onClearLoading: () => {
            this.paymentLoading = false
          }
        })
      } else {
        this.$store.commit('setPaysolutionCustomerData', undefined)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
